import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const MetadataForm = ({ formData, onChange, errors, selectedPersona }) => {
  const allegationTypes = [
    { value: 'electrical', label: 'Electrical Failure' },
    { value: 'appliance', label: 'Appliance Malfunction' },
    { value: 'arson', label: 'Suspected Arson' },
    { value: 'smoking', label: 'Smoking Materials' },
    { value: 'cooking', label: 'Cooking Equipment' },
    { value: 'heating', label: 'Heating Equipment' },
    { value: 'lightning', label: 'Lightning Strike' },
    { value: 'wildfire', label: 'Wildfire Spread' },
    { value: 'unknown', label: 'Unknown/Undetermined' },
    { value: 'other', label: 'Other' },
  ];

  const propertyTypes = [
    { value: 'residential-single', label: 'Residential - Single Family' },
    { value: 'residential-multi', label: 'Residential - Multi-Family' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' },
    { value: 'vehicle', label: 'Vehicle' },
    { value: 'wildland', label: 'Wildland/Forest' },
    { value: 'other', label: 'Other' },
  ];

  const handleInputChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Incident Date"
          type="date"
          required
          value={formData?.incidentDate || ''}
          onChange={(e) => handleInputChange('incidentDate', e?.target?.value)}
          error={errors?.incidentDate}
          max={new Date()?.toISOString()?.split('T')?.[0]}
        />

        <Input
          label="Incident Time (if known)"
          type="time"
          value={formData?.incidentTime || ''}
          onChange={(e) => handleInputChange('incidentTime', e?.target?.value)}
        />
      </div>
      <Input
        label="Property Address"
        type="text"
        required
        placeholder="123 Main Street, City, State ZIP"
        value={formData?.propertyAddress || ''}
        onChange={(e) => handleInputChange('propertyAddress', e?.target?.value)}
        error={errors?.propertyAddress}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Property Type"
          required
          options={propertyTypes}
          value={formData?.propertyType || ''}
          onChange={(value) => handleInputChange('propertyType', value)}
          error={errors?.propertyType}
          placeholder="Select property type"
        />

        <Select
          label="Allegation Type"
          required
          options={allegationTypes}
          value={formData?.allegationType || ''}
          onChange={(value) => handleInputChange('allegationType', value)}
          error={errors?.allegationType}
          placeholder="Select allegation type"
        />
      </div>
      {selectedPersona === 'insurance-adjuster' && (
        <Input
          label="Claim Number"
          type="text"
          placeholder="CLM-2026-001234"
          value={formData?.claimNumber || ''}
          onChange={(e) => handleInputChange('claimNumber', e?.target?.value)}
        />
      )}
      {(selectedPersona === 'plaintiff-attorney' || selectedPersona === 'defense-attorney') && (
        <Input
          label="Case Number"
          type="text"
          placeholder="CV-2026-001234"
          value={formData?.caseNumber || ''}
          onChange={(e) => handleInputChange('caseNumber', e?.target?.value)}
        />
      )}
      {selectedPersona === 'prosecutor' && (
        <Input
          label="Criminal Case Number"
          type="text"
          placeholder="CR-2026-001234"
          value={formData?.criminalCaseNumber || ''}
          onChange={(e) => handleInputChange('criminalCaseNumber', e?.target?.value)}
        />
      )}
      <Input
        label="Estimated Loss Amount (USD)"
        type="number"
        placeholder="0.00"
        value={formData?.estimatedLoss || ''}
        onChange={(e) => handleInputChange('estimatedLoss', e?.target?.value)}
        min="0"
        step="0.01"
      />
      <div>
        <label className="block text-sm font-medium mb-2">
          Additional Context <span className="text-muted-foreground">(Optional)</span>
        </label>
        <textarea
          className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
          rows="4"
          placeholder="Provide any additional context, witness statements, or relevant information..."
          value={formData?.additionalContext || ''}
          onChange={(e) => handleInputChange('additionalContext', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default MetadataForm;